import { Components, Theme } from '@mui/material'

export const MuiFormControl: Components<Omit<Theme, 'components'>>['MuiFormControl'] = {
  defaultProps: {
    size: 'small',
  },
}
